export default {
  AUTH0_RESPONSE_TYPE: 'token id_token',
};
